"use strict";
exports.__esModule = true;
exports.APIQueryParamFragments = void 0;
var APIQueryParamFragments;
(function (APIQueryParamFragments) {
    APIQueryParamFragments["APP_VERSION"] = "app_version";
    APIQueryParamFragments["ORGANISATION_ID"] = "organisation_id";
    APIQueryParamFragments["USER_ID"] = "user_id";
    APIQueryParamFragments["EMAIL"] = "email";
    APIQueryParamFragments["IS_ARCHIVED"] = "is_archived";
    APIQueryParamFragments["FIELD_NAME"] = "field_name";
    APIQueryParamFragments["ENTITY_TYPE"] = "entity_type";
    APIQueryParamFragments["ENTITY_ID"] = "entity_id";
    APIQueryParamFragments["SOURCE"] = "source";
    APIQueryParamFragments["START"] = "start";
    APIQueryParamFragments["LIMIT"] = "limit";
    APIQueryParamFragments["SEARCH"] = "search";
})(APIQueryParamFragments = exports.APIQueryParamFragments || (exports.APIQueryParamFragments = {}));
